import * as React from 'react';

import Upload16 from './Upload16';

export const upload16 = () => <Upload16 />;

export default {
    title: 'Icon|Line|Upload16',
    component: Upload16,
    parameters: {
        notes: "`import Upload16 from 'box-ui-elements/es/icon/line/Upload16';`",
    },
};
